import { render, staticRenderFns } from "./away.vue?vue&type=template&id=85018528&"
import script from "./away.vue?vue&type=script&lang=js&"
export * from "./away.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports